/* ============================================================
   devfo.js — custom theme scripts
   ============================================================ */

/* ------------------------------------------------------------
   Size guide (pasted into a page's HTML content)

   Shopify's page editor strips <script>, <style> and <input>
   tags from page content, so the page only holds plain markup —
   all styling lives in devfo.css and all behaviour lives here.
   ------------------------------------------------------------ */
(function () {
  function initSizeGuide(root) {
    // Tracked as a JS property, NOT a data- attribute: the theme's tool-tip
    // popup builds itself by copying innerHTML, so an attribute would be
    // copied into the popup's clone and make it look already-initialised —
    // skipping it and leaving it with no click handlers.
    if (!root || root.__ozjwSgReady) return;
    root.__ozjwSgReady = true;

    var unit = 'cm';

    function num(v) {
      return parseFloat(String(v).replace(/[^0-9.\-]/g, ''));
    }

    function withUnit(v) {
      var n = num(v);
      if (isNaN(n)) return String(v).trim();
      return (unit === 'in' ? Math.round((n / 2.54) * 10) / 10 : Math.round(n * 10) / 10) + ' ' + unit;
    }

    function bare(v) {
      var n = num(v);
      if (isNaN(n)) return String(v).trim();
      return String(unit === 'in' ? Math.round((n / 2.54) * 10) / 10 : Math.round(n * 10) / 10);
    }

    function setClass(el, cls, on) {
      if (!el) return;
      var classes = el.className.split(/\s+/).filter(function (c) { return c && c !== cls; });
      if (on) classes.push(cls);
      el.className = classes.join(' ');
    }

    function renderPanel(panel) {
      var active = panel.querySelector('.sg-size.is-active');
      if (!active) return;

      var labels = (panel.getAttribute('data-labels') || '').split(',');
      var values = (active.getAttribute('data-values') || '').split(',');

      var sizeEl = panel.querySelector('.sg-result-size');
      var badgeEl = panel.querySelector('.sg-result-badge');
      if (sizeEl) sizeEl.textContent = active.getAttribute('data-label') || '';
      if (badgeEl) badgeEl.textContent = active.getAttribute('data-badge') || '';

      var rowsEl = panel.querySelector('.sg-result-rows');
      if (rowsEl) {
        var html = '';
        for (var i = 0; i < labels.length; i++) {
          var label = (labels[i] || '').trim();
          if (!label) continue;
          var raw = values[i] === undefined ? '' : values[i].trim();
          html +=
            '<div class="sg-row">' +
              '<span class="sg-row-label">' + label + '</span>' +
              '<span class="sg-row-value">' + (raw ? withUnit(raw) : '—') + '</span>' +
            '</div>';
        }
        rowsEl.innerHTML = html;
      }

      var cells = panel.querySelectorAll('[data-raw]');
      for (var c = 0; c < cells.length; c++) {
        cells[c].textContent = bare(cells[c].getAttribute('data-raw'));
      }

      var activeLabel = active.getAttribute('data-label');
      var rows = panel.querySelectorAll('[data-chart-row]');
      for (var r = 0; r < rows.length; r++) {
        setClass(rows[r], 'is-current', rows[r].getAttribute('data-chart-row') === activeLabel);
      }
    }

    function renderAll() {
      var panels = root.querySelectorAll('.sg-panel');
      for (var i = 0; i < panels.length; i++) renderPanel(panels[i]);
    }

    function closest(el, selector) {
      while (el && el !== root.parentNode) {
        if (el.nodeType === 1 && el.matches && el.matches(selector)) return el;
        el = el.parentNode;
      }
      return null;
    }

    root.addEventListener('click', function (e) {
      var target = e.target;

      var toggle = closest(target, '.sg-chart-toggle');
      if (toggle) {
        var panel = closest(toggle, '.sg-panel');
        var chart = panel && panel.querySelector('.sg-chart');
        if (!chart) return;
        var show = chart.className.indexOf('is-hidden') !== -1;
        setClass(chart, 'is-hidden', !show);
        setClass(toggle, 'is-open', show);
        toggle.textContent = show
          ? (toggle.getAttribute('data-hide') || 'Hide full chart')
          : (toggle.getAttribute('data-show') || 'View full chart');
        return;
      }

      var tab = closest(target, '.sg-tab');
      if (tab) {
        var index = tab.getAttribute('data-tab');
        var tabs = root.querySelectorAll('.sg-tab');
        for (var t = 0; t < tabs.length; t++) setClass(tabs[t], 'is-active', tabs[t] === tab);
        var panels = root.querySelectorAll('.sg-panel');
        for (var p = 0; p < panels.length; p++) {
          setClass(panels[p], 'is-hidden', panels[p].getAttribute('data-panel') !== index);
        }
        return;
      }

      var unitBtn = closest(target, '.sg-unit');
      if (unitBtn) {
        unit = unitBtn.getAttribute('data-unit') || 'cm';
        var units = root.querySelectorAll('.sg-unit');
        for (var u = 0; u < units.length; u++) setClass(units[u], 'is-active', units[u] === unitBtn);
        var note = root.querySelector('.sg-unit-note-text');
        if (note) {
          note.textContent = unit === 'in' ? 'Measurements in inches' : 'Measurements in centimeters';
        }
        renderAll();
        return;
      }

      var size = closest(target, '.sg-size');
      if (size) {
        var sizePanel = closest(size, '.sg-panel');
        if (!sizePanel) return;
        var sizes = sizePanel.querySelectorAll('.sg-size');
        for (var s = 0; s < sizes.length; s++) setClass(sizes[s], 'is-active', sizes[s] === size);
        renderPanel(sizePanel);
      }
    });

    renderAll();
  }

  function initAll() {
    var guides = document.querySelectorAll('.ozjw-sg');
    for (var i = 0; i < guides.length; i++) initSizeGuide(guides[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // The theme shows the size guide inside a popup that clones page content,
  // so re-scan when new nodes appear rather than only on load.
  if (window.MutationObserver) {
    var observer = new MutationObserver(function () { initAll(); });
    observer.observe(document.body || document.documentElement, { childList: true, subtree: true });
  }
})();
